const features = [
  {
    icon: 'ri-stack-line',
    title: '多站聚合',
    desc: '整合奇优影院、98影院、优优色影院、cc影院、96影院六大热门站点，一个入口畅享全网资源，告别多站切换烦恼。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '每日更新',
    desc: '每日200+新片源及时上线，热门剧集播出后数小时内同步更新，不错过任何精彩内容，追剧观影快人一步。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '高清流畅',
    desc: '支持720P到4K多档清晰度选择，服务器全面升级保证播放稳定流畅，无论是手机还是电脑都能获得优质观影体验。',
  },
  {
    icon: 'ri-global-line',
    title: '品类齐全',
    desc: '覆盖电影、电视剧、综艺、动漫、纪录片五大品类20余子分类，10万+影视内容持续扩充，满足全家观影需求。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">平台优势</h2>
          <p className="text-sm text-foreground-500">为什么选择51影院？四大核心优势让你观影无忧</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {features.map((f, i) => (
            <div
              key={i}
              className="group p-6 rounded-lg bg-background-100 border border-background-200/40 hover:border-primary-500/20 transition-all text-center"
            >
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-xl bg-primary-500/15 text-primary-400 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${f.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-100 mb-3">{f.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}